<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> {{$t('pages.yearCCData.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-printer" @click="printlist">{{$t('pages.yearCCData.print')}}</el-button>
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">{{$t('pages.yearCCData.export')}}</el-button>
                <span class="toptotalWeight">
                    {{$t('pages.yearCCData.annualCapacity')}}:
                    <el-input v-model="annualCapacity" class="handle-select2" disabled></el-input>
                    {{$t('pages.yearCCData.monthlyCapacity')}}:
                    <el-input v-model="monthlyCapacity" class="handle-select2" disabled></el-input>
                    {{$t('pages.yearCCData.annualOutput')}}:
                    <el-input v-model="annualOutput" class="handle-select2" disabled></el-input>
                    {{$t('pages.yearCCData.annualCapacityRatio')}}:
                    <el-input v-model="annualCapacityRatio" class="handle-select2" disabled></el-input>
                    {{$t('pages.yearCCData.overproductionNum')}}:
                    <el-input v-model="overproductionNum" class="handle-select2" disabled></el-input>
                </span>
            </div>
            <div class="handle-headright">
                <el-date-picker v-model="query.Years" type="year" :placeholder="$t('pages.yearCCData.yearPh')" class="handle-select mr10" :picker-options="pickerOptions0"></el-date-picker>
                <el-select v-model="query.balanceId" :placeholder="$t('pages.yearCCData.scale')" class="handle-select mr10">
                    <el-option v-for="item in balanceArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.yearCCData.search')}}</el-button>
            </div>
        </div>

        <el-table :data="logRecords" border class="table" header-cell-class-name="table-header" id="mytable" ref="mytable" :height="tableHeight">
            <el-table-column type="index" width="80" :label="$t('pages.yearCCData.index')"></el-table-column>
            <el-table-column :prop="isDisplayCompanyName ? 'fullBalanceName' : 'balanceName'" :label="$t('pages.yearCCData.scaleName')"></el-table-column>
            <el-table-column :label="$t('pages.yearCCData.overWeight')">
                <template slot-scope="scope">
                    <el-button type="text" style="color: #606266; font-size: 15px; padding-top: 0px; padding-bottom: 8px">{{ scope.row.weight }}</el-button>
                </template>
            </el-table-column>
            <el-table-column :label="$t('pages.yearCCData.monthCnb')">
                <template slot-scope="scope">
                    <el-button type="text" style="color: #606266; font-size: 15px; padding-top: 0px; padding-bottom: 8px">{{ scope.row.monthCNB }}</el-button>
                </template>
            </el-table-column>
            <el-table-column :label="$t('pages.yearCCData.overproductionStatus')" width="180">
                <template slot-scope="scope">
                    <el-tag size="mini" :type="getOverproductionTagType(scope.row.monthCNB)">{{ getOverproductionText(scope.row.monthCNB) }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column :label="$t('pages.yearCCData.overproductionDateMonth')">
                <template slot-scope="scope">
                    <el-button type="text" style="color: #606266; font-size: 15px; padding-top: 0px; padding-bottom: 8px">{{ scope.row.overproductionDate }}</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    SortField,
    dateAdd
} from '../../utils/helper';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'logRecord',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
            isDisplayCompanyName: false,
            tableHeight: window.innerHeight * 0.75,
            annualCapacity: '',
            monthlyCapacity: '',
            annualOutput: '',
            annualCapacityRatio: '',
            overproductionNum: '',
            frequencyArr: [],
            balanceArr: [],
            logRecords: [],
            multipleSelection: [],
            query: {
                Years: '',
                balanceId: 0
            }
        };
    },
    filters: {
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy年');
        }
    },
    created() {
        this.query.Years = new Date();
        this.getBalance();
        this.getData();
    },
    methods: {
        getData() {
            var year = new Date(this.query.Years).getFullYear();
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .get('OverproductionQuery/YearCCData', {
                    params: {
                        balanceId: this.query.balanceId,
                        Year: year,
                        CreateUserId: userInfo.id,
                        UserName: userInfo.realName
                    }
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.logRecords = d;
                        this.annualCapacity = res.data.info1;
                        this.monthlyCapacity = res.data.info2;
                        this.annualOutput = res.data.msg;
                        this.annualCapacityRatio = res.data.info3;
                        this.isDisplayCompanyName = res.data.info4 == this.$t('pages.yearCCData.yes') ? true : false;
                        this.overproductionNum = res.data.data.count;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.yearCCData.fetchError')));
        },
        getBalance() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Balance/GetList', {
                    Field1: userInfo.userType,
                    Field2: userInfo.id + '',
                    Field3: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.balanceArr = [{
                            id: 0,
                            name: this.$t('pages.yearCCData.all')
                        }].concat(d).sort(SortField('id', 'asc'));
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.yearCCData.fetchError')));
        },
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy年');
        },
        printlist() {
            var newdata = JSON.parse(JSON.stringify(this.logRecords));
            // 进行格式处理的数据
            newdata.forEach((item, index, arr) => {
                item.index = index + 1;
                item.date = this.formateData(item.date); // 日期格式处理
                item.overproductionStatus = this.getOverproductionText(item.monthCNB);
            });
            // 打印方法
            print({
                printable: newdata,
                header: `<div style="display: flex;flex-direction: column;text-align: center">
                        <h3>${this.$t('pages.yearCCData.printTitle')}</h3>
                    </div>`,
                properties: [{
                        field: 'index',
                        displayName: this.$t('pages.yearCCData.index'),
                        columnSize: `5%`
                    },
                    {
                        field: this.isDisplayCompanyName ? 'fullBalanceName' : 'balanceName',
                        displayName: this.$t('pages.yearCCData.scaleName')
                    },
                    {
                        field: 'weight',
                        displayName: this.$t('pages.yearCCData.overWeight'),
                        columnSize: `10%`
                    },
                    {
                        field: 'monthCNB',
                        displayName: this.$t('pages.yearCCData.monthCnb'),
                        columnSize: `10%`
                    },
                    {
                        field: 'overproductionStatus',
                        displayName: this.$t('pages.yearCCData.overproductionStatus'),
                        columnSize: `10%`
                    },
                    {
                        field: 'overproductionDate',
                        displayName: this.$t('pages.yearCCData.overproductionDateMonth'),
                        columnSize: `10%`
                    }
                ],
                type: 'json',
                gridHeaderStyle: 'border: 1px solid #000;text-align:center;padding:6px;0px;',
                gridStyle: 'border: 1px solid #000;text-align:left;padding:5px;10px;'
            });
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(new Blob([wbout], {
                    type: 'application/octet-stream'
                }), this.$t('pages.yearCCData.printTitle') + name + '.xlsx');
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        },
        indexMethod(index) {
            return index + 1;
        },
        parseCnbToRatio(val) {
            if (val === null || val === undefined) {
                return null;
            }
            if (typeof val === 'number') {
                if (!Number.isFinite(val)) {
                    return null;
                }
                return val > 10 ? val / 100 : val;
            }
            const s = String(val).trim();
            if (!s) {
                return null;
            }
            const hasPercent = s.indexOf('%') > -1;
            const n = parseFloat(s.replace('%', ''));
            if (!Number.isFinite(n)) {
                return null;
            }
            if (hasPercent) {
                return n / 100;
            }
            return n > 10 ? n / 100 : n;
        },
        getOverproductionLevel(val) {
            const ratio = this.parseCnbToRatio(val);
            if (ratio === null) {
                return {
                    level: 'unknown',
                    exceedPercent: null
                };
            }
            const exceedPercent = (ratio - 1) * 100;
            if (exceedPercent > 10) {
                return {
                    level: 'severe',
                    exceedPercent
                };
            }
            if (exceedPercent > 0) {
                return {
                    level: 'over',
                    exceedPercent
                };
            }
            return {
                level: 'normal',
                exceedPercent
            };
        },
        getOverproductionText(val) {
            const info = this.getOverproductionLevel(val);
            if (info.level === 'unknown') {
                return '--';
            }
            const p = Math.abs(info.exceedPercent).toFixed(2) + '%';
            if (info.level === 'severe') {
                return `${this.$t('pages.yearCCData.severeOverproduction')}（${this.$t('pages.yearCCData.exceed')} ${p}）`;
            }
            if (info.level === 'over') {
                return `${this.$t('pages.yearCCData.overproduction')}（${this.$t('pages.yearCCData.exceed')} ${p}）`;
            }
            return this.$t('pages.yearCCData.normal');
        },
        getOverproductionTagType(val) {
            const info = this.getOverproductionLevel(val);
            if (info.level === 'severe') {
                return 'danger';
            }
            if (info.level === 'over') {
                return 'warning';
            }
            if (info.level === 'normal') {
                return 'success';
            }
            return 'info';
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-select2 {
    width: 80px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.toptotalWeight {
    float: right;
    margin-left: 30px;
}
</style>
